import { type ComponentProps, forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';

import { MotionPicture, Picture } from '../Picture/Picture';

import css from './styles.module.scss';

import assistantPng from '/img/icons/helpCards/presentation-assistant.png';
import assistantWepb from '/img/icons/helpCards/presentation-assistant.webp';
import lightGreenPng from '/img/light-green.png';
import lightGreenWebp from '/img/light-green.webp';

interface PictureAnimationProps extends ComponentProps<typeof MotionPicture> {
  key: string;
}

interface AssistantProps extends HTMLAttributes<HTMLDivElement> {
  characterImage?: {
    main: string;
    webp?: string;
  };
  label?: string;
  pictureAnimation?: PictureAnimationProps;
}

const Assistant = forwardRef<HTMLDivElement, AssistantProps>(
  ({ characterImage, label, pictureAnimation, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(props.className, 'cursor-pointer')}
      >
        <div className="relative flex flex-col items-center">
          <Picture
            img={lightGreenPng}
            webp={lightGreenWebp}
            alt="light"
            className="absolute z-[-1] w-[4.5rem] to-0.5"
          />
          <MotionPicture
            {...pictureAnimation}
            className="w-12 h-12 rounded-full block"
            img={characterImage?.main || assistantPng}
            webp={characterImage?.webp || assistantWepb}
            alt={'assistant'}
          />
          {children}
          {label && <div className={css.label}>{label}</div>}
          {label && <span className={css.effect}></span>}
        </div>
      </div>
    );
  },
);

export { Assistant };
